var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"rsv-button",class:_vm.allClasses,attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }